import {Button} from 'react-bootstrap';
import './ClaimOfferButton.css';

const ClaimOfferButton = (props) => {
    return (
        <Button onClick={() => {
          console.log(props)
          props.refProp.current.scrollIntoView({})
        }} className='btnClaim'>CLAIM YOUR OFFER</Button>
    )
}

export default ClaimOfferButton;
